import React from 'react';

import {ShibuyaCannesSaleConfig} from '@/utils/types';

export type CannesToken = {
  id: 0 | 1 | 2 | 3 | 4 | 5;
  tier: 'gold' | 'silver' | 'bronze';
  title: string;
  description: React.ReactNode;
  price: string;
  datetime: string;
  slug: string;
  video: {mp4: string; webm: string; gif: string};
  supply: number;
  available: number;
};

export const CANNES_DEFAULT_TOKENS: Array<CannesToken> = [
  {
    id: 0,
    tier: 'gold',
    title: 'Opening Glitter',
    description:
      'Holders invited to attend the red carpet and opening ceremony.',
    price: '7000000000000000000',
    datetime: 'May 17, 2022',
    slug: 'opening-ceremony',
    video: {
      mp4: 'https://stream.mux.com/TVyYpZ3NNsMU9Gnb4o96FVqTixXk01Fcd5yYxFN3OvDc.m3u8',
      webm: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-gold-opening.webm',
      gif: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-gold-opening.gif',
    },
    supply: 7,
    available: 0,
  },
  {
    id: 1,
    tier: 'gold',
    title: 'Closing Confetti',
    description:
      'Holders invited to attend the red carpet and closing ceremony.',
    price: '7000000000000000000',
    datetime: 'May 28, 2022',
    slug: 'closing-ceremony',
    video: {
      mp4: 'https://stream.mux.com/D018SazacVkjhdCfwDL028UILyiDJlHkrryexNh7Hpr9M.m3u8',
      webm: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-gold-closing.webm',
      gif: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-gold-closing.gif',
    },
    supply: 6,
    available: 0,
  },
  {
    id: 2,
    tier: 'silver',
    title: 'Danger Zone',
    description: (
      <span>
        Holders invited to the red carpet and viewing of{' '}
        <span className="font-medium text-gray-300">Top Gun: Maverick</span>.
      </span>
    ),
    price: '6000000000000000000',
    datetime: 'May 18, 2022',
    slug: 'top-gun-movie',
    video: {
      mp4: 'https://stream.mux.com/QbpuyAkWYq3FiZchB3SHt1A74027isyOFqlrHwpXh4as.m3u8',
      webm: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-silver-topgun.webm',
      gif: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-silver-topgun.gif',
    },
    supply: 4,
    available: 0,
  },
  {
    id: 3,
    tier: 'silver',
    title: 'King of Rock & Roll',
    description: (
      <span>
        Holders invited to the red carpet and viewing of{' '}
        <span className="font-medium text-gray-300">Elvis</span>.
      </span>
    ),
    price: '6000000000000000000',
    datetime: 'May 25, 2022',
    slug: 'elvis-movie',
    video: {
      mp4: 'https://stream.mux.com/OeajbZLzlEz8Q015a2SYfFOdz02S7uM7XNzCsx02C02x8AQ.m3u8',
      webm: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-silver-elvis.webm',
      gif: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-silver-elvis.gif',
    },
    supply: 4,
    available: 0,
  },
  {
    id: 4,
    tier: 'silver',
    title: 'Scholar and Djinn',
    description: (
      <span>
        Holders invited to the red carpet and viewing of{' '}
        <span className="font-medium text-gray-300">
          Three Thousand Years of Longing
        </span>
        .
      </span>
    ),
    price: '6000000000000000000',
    datetime: 'May 20, 2022',
    slug: 'three-thousand-years-movie',
    video: {
      mp4: 'https://stream.mux.com/R46TDFeXehcP5WEuF101kNeBslc1v3i2YQ7s6zvGOaJU.m3u8',
      webm: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-silver-threethousand.webm',
      gif: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-silver-threethousand.gif',
    },
    supply: 4,
    available: 0,
  },
  {
    id: 5,
    tier: 'bronze',
    title: 'Film Lover',
    description:
      'Holders invited to the red carpet and a film showing for one day of the festival.',
    price: '5000000000000000000',
    // TODO: dates will vary here...
    datetime: 'May 18, 2022 - May 28, 2022',
    slug: 'basic',
    video: {
      mp4: 'https://stream.mux.com/PPnbvGIWqxClEAuKFfW4y02rsIo5nFfY8vfqoKRMmPzI.m3u8',
      webm: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-bronze-general.webm',
      gif: 'https://storage.googleapis.com/shibuya-cannes-2022/cannes-bronze-general.gif',
    },
    supply: 50,
    available: 0,
  },
];

export const calculatePriceByTier = (
  config: ShibuyaCannesSaleConfig,
  tier: string
) => {
  switch (tier) {
    case 'gold':
      return config.goldTierPrice;
    case 'silver':
      return config.silverTierPrice;
    case 'bronze':
      return config.bronzeTierPrice;
    default:
      throw new Error(`Invalid tier: ${tier}`);
  }
};
